export default __webpack_public_path__ + "static/media/42.142327e2.jpg";